export function assertIsBoolean(variable: any): asserts variable is boolean {
  if (typeof variable !== "boolean") {
    throw new Error(
      `Expected variable ${JSON.stringify(
        variable
      )} to be a boolean! It was instead ${typeof variable}`
    );
  }
}
